export default "__VITE_ASSET__DMuIkV9N__"